<h1>
  Compute your Annual Budget
  <button
    type="button"
    class="close pull-right"
    aria-label="close"
    (click)="close()"
  >
    <span aria-hidden="true">×</span>
  </button>
</h1>
<div class="pay-row fm-row mt-3 mb-4">
  <p>Do you have any savings(529) that you want to use over 4 years?</p>
  <div class="row">
    <div class="containvalue col-md-6">
      <select [(ngModel)]="selectedOption">
        <option value="no">No</option>
        <option value="yes">Yes</option>
      </select>
    </div>
    <!-- efc-cl cust-div-link max-cost -->
    <div class="col-md-6">
      <div
        class="form-control cust-div-link max-cost pay-row fm-row"
        *ngIf="selectedOption === 'yes'"
      >
        <span>$</span>
        <tui-input-number
          class="currency-input"
          style="display: inline-block; width: 94%; padding-right: 0px"
          type="text"
          [(ngModel)]="value1"
          [prefix]="''"
          [tuiTextfieldLabelOutside]="'true'"
          [pseudoHovered]="'true'"
          [max]="999999999999999"
          [pseudoFocused]="'true'"
          class=""
          id="exampleInputPassword1"
        >
          <input
            class="out-max"
            tuiTextfield
            placeholder="Enter total savings amount"
          />
        </tui-input-number>
        <!-- <div class="Add">
          <p>Enter total savings amount</p>
        </div> -->
      </div>
    </div>
  </div>
</div>
<div class="pay-row fm-row mt-3 mb-4">
  <p>
    Would you be using a portion of your monthly cash flow towards college
    spending?
  </p>
  <div class="row">
    <div class="containvalue col-md-6">
      <select [(ngModel)]="selectedOption1">
        <option value="no">No</option>
        <option value="yes">Yes</option>
      </select>
    </div>
    <!-- efc-cl cust-div-link max-cost -->
    <div class="col-md-6">
      <div
        class="form-control cust-div-link max-cost pay-row fm-row"
        *ngIf="selectedOption1 === 'yes'"
      >
        <span>$</span>
        <tui-input-number
          class="currency-input"
          style="display: inline-block; width: 94%; padding-right: 0px"
          type="text"
          [(ngModel)]="value2"
          [prefix]="''"
          [tuiTextfieldLabelOutside]="'true'"
          [pseudoHovered]="'true'"
          [max]="999999999999999"
          [pseudoFocused]="'true'"
          class=""
          id="exampleInputPassword1"
        >
          <input
            class="out-max"
            tuiTextfield
            placeholder="Enter Monthly Amount"
          />
        </tui-input-number>
        <div
          class="text-sm text-blue-400 italic italic absolute cust-subline mt-2 text-right"
        >
          Enter Monthly Amount
        </div>
      </div>
    </div>
  </div>
</div>
<div class="pay-row fm-row mt-3 mb-4">
  <p>
    If you file a FAFSA, you will be eligible for up to <b>$5,500</b> (minus
    federal fees) of student loans this year. How much, if any of it would you
    like to apply towards college spending?
  </p>
  <div class="row">
    <div class="containvalue col-md-6">
      <select [(ngModel)]="selectedOption2">
        <option value="no">No</option>
        <option value="yes">Yes</option>
      </select>
    </div>
    <!-- efc-cl cust-div-link max-cost -->
    <div class="col-md-6">
      <div
        class="form-control cust-div-link max-cost pay-row fm-row"
        *ngIf="selectedOption2 === 'yes'"
        [ngClass]="studentloan ? 'inputBorderError' : ''"
      >
        <span>$</span>
        <tui-input-number
          class="currency-input"
          style="display: inline-block; width: 94%; padding-right: 0px"
          type="text"
          [(ngModel)]="value3"
          [prefix]="''"
          [tuiTextfieldLabelOutside]="'true'"
          [pseudoHovered]="'true'"
          [max]="999999999999999"
          [pseudoFocused]="'true'"
          (keyup)="formatValue(value3)"
          class=""
          id="exampleInputPassword1"
        >
          <!-- [ngClass]="loanValueBorderError ? 'inputBorderError' : ''"  -->
          <input
            class="out-max"
            tuiTextfield
            placeholder="Enter Annual Contribution"
          />
        </tui-input-number>
        <div
          class="text-sm text-blue-400 italic italic absolute cust-subline mt-2 text-right"
        >
          Enter Annual Contribution
        </div>
      </div>
      <div class="text-red-400" *ngIf="studentloan == true">
        Loan contribution can't be greater than total loan amount
      </div>
    </div>
  </div>
</div>
<div class="pay-row fm-row mt-3 mb-4">
  <p>
    How much additional credit-based loan funding (PLUS or Private loan), if
    any, are you planning on applying towards college spending?
  </p>
  <div class="row">
    <div class="containvalue col-md-6">
      <select [(ngModel)]="selectedOption3">
        <option value="no">No</option>
        <option value="yes">Yes</option>
      </select>
    </div>
    <!-- efc-cl cust-div-link max-cost -->
    <div class="col-md-6">
      <div
        class="form-control cust-div-link max-cost pay-row fm-row"
        *ngIf="selectedOption3 === 'yes'"
      >
        <span>$</span>
        <tui-input-number
          class="currency-input"
          style="display: inline-block; width: 94%; padding-right: 0px"
          type="text"
          [(ngModel)]="value4"
          [prefix]="''"
          [tuiTextfieldLabelOutside]="'true'"
          [pseudoHovered]="'true'"
          [max]="999999999999999"
          [pseudoFocused]="'true'"
          class=""
          id="exampleInputPassword1"
        >
          <input
            class="out-max"
            tuiTextfield
            placeholder="Enter Annual Contribution"
          />
        </tui-input-number>
        <div
          class="text-sm text-blue-400 italic italic absolute cust-subline mt-2 text-right"
        >
          Enter Annual Contribution
        </div>
      </div>
    </div>
  </div>
</div>

<p class="sum-tl">
  Your Estimated Annual Budget: <strong>{{ sum() }}</strong>
</p>

<p class="note-pay">
  Disclaimer: All calculations assume a 4-year college term.
</p>
<div class="text-center">
  <!-- <a class="btn page-btn mx-1" (click)="close()">Close</a> -->
  <a
    class="btn page-btn mx-1"
    [ngClass]="studentloan == true ? 'disableancher' : ''"
    (click)="savedata()"
    >Save & Proceed</a
  >
</div>
